import { ButtonIcon } from '@dapp/multi-lib/sdaoui/ButtonIcon';
import { ValuesOfMap } from '@dapp/multi-lib/lib/utilityTypes';
import { Icon } from '@dapp/multi-lib/sdaoui/Icon';
import { useVaultListContext } from 'structure/pv2/dynavault/context/VaultListContext';

export const ViewType = {
  TABLE: 'table',
  CARD: 'card',
} as const;

export type ViewTypes = ValuesOfMap<typeof ViewType>;

export const ViewTypeSwitch = () => {
  const { viewType, setViewType } = useVaultListContext();

  return (
    <div className='flex flex-row gap-1'>
      <ButtonIcon
        className='h-[24px] w-[24px] p-0 lg:h-[34px] lg:w-[34px] lg:p-[6px]'
        onClick={() => setViewType(ViewType.CARD)}
      >
        <Icon
          width='100%'
          height='100%'
          icon={'apps'}
          color={viewType === ViewType.CARD ? '#F0F0F0' : '#595959'}
        />
      </ButtonIcon>
      <ButtonIcon
        className='h-[24px] w-[24px] p-0 lg:h-[34px] lg:w-[34px] lg:p-[6px]'
        onClick={() => setViewType(ViewType.TABLE)}
      >
        <Icon
          width='100%'
          height='100%'
          icon={'list_outline'}
          color={viewType === ViewType.TABLE ? '#F0F0F0' : '#595959'}
        />
      </ButtonIcon>
    </div>
  );
};
